import { Injectable } from '@angular/core';
import { ToastController, Platform } from '@ionic/angular';

@Injectable({
  providedIn: 'root'
})
export class ToastService {
  toasts: Array<HTMLIonToastElement>=[];
  private isToastPresent = false;
  constructor(
    private toastCtrl: ToastController,
    private platform: Platform
  ) {}
  async presentSuccessToast(

    message,
    position: 'top'|'bottom'|'middle' = 'top',
    options= {duration: 3000},
    onDidDismiss: (res) => any = (res) => {},
    showViewButton: boolean = false,
    viewButtonHandler?: () => void
  ) {
    const isMobile = this.platform.is('capacitor') && (this.platform.is('android') || this.platform.is('ios'));
    
    // Only prevent showing toast on web/non-mobile for file saved messages
    const isFileSavedMessage = message && typeof message === 'string' && 
      (message.toLowerCase().includes('file saved') || message.toLowerCase().includes('saved to device'));
    
    if (isFileSavedMessage && !isMobile) {
      // Don't show toast on web/non-mobile devices for file save messages
      return Promise.resolve();
    }
    
    const toastOptions: any = {
      color: 'success',
      message,
      position,
      cssClass: 'custom-toast',
      ...options,
    };

    // Add View button only on mobile devices when showViewButton is true
    if (isMobile && showViewButton && viewButtonHandler) {
      toastOptions.buttons = [
        {
          text: 'View',
          handler: () => {
            viewButtonHandler();
          }
        }
      ];
    }

    const toastsLen = this.toasts.push(await this.toastCtrl.create(toastOptions));
    if (this.isToastPresent) {
      // If a toast is already being displayed, do not show a new one
      return;
    }
    this.isToastPresent = true;
    const toast = this.toasts[toastsLen-1];
    toast.present();
    toast.onDidDismiss().then(res => {
      this.toasts.filter(tst => tst === toast);
      this.isToastPresent = false;
      onDidDismiss(res);
    });
    return Promise.resolve();
  }
  async presentErrorToast(

    message,
    position: 'top'|'bottom'|'middle' = 'top',
    options= {duration: 3000},
    onDidDismiss: (res) => any = (res) => {}
  ) {
    message = message ?? 'Something went wrong'
    const toastsLen = this.toasts.push(await this.toastCtrl.create({
      color: 'danger',
      message,
      position,
      cssClass: 'custom-toast' ,
      ...options
    }));


    const toast = this.toasts[toastsLen-1];
    if (this.isToastPresent) {
      // If a toast is already being displayed, do not show a new one
      return;
    }
    this.isToastPresent=true;
    toast.present();
    toast.onDidDismiss().then(res => {
      this.toasts.filter(tst => tst === toast);
      this.isToastPresent=false;
      onDidDismiss(res);
    });
    return Promise.resolve();
  }
  dismissAllToast() {
    if (this.toasts) {
      this.toasts.forEach(toast => {
        toast.dismiss();
      });
    }
  }
}